var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.442,
    height: 30.41,
    viewBox: "0 0 33.442 30.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2033c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#d70235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c10230"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back_gradient",
    "data-name": "back gradient",
    transform: "translate(33.442 30.41) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30000",
    "data-name": "Group 30000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23596",
    "data-name": "Path 23596",
    d: "M32.442,14.1H3.413l12.4-12.4A1,1,0,1,0,14.4.293L.292,14.4a1.014,1.014,0,0,0-.216.326,1,1,0,0,0,0,.764,2.657,2.657,0,0,0,.418.527l14.1,14.1A1,1,0,1,0,16.011,28.7L3.413,16.1H32.442a1,1,0,0,0,0-2",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.bd45994822ecc3e70281c9b45fb20b72.svg";
export { ForwardRef as ReactComponent };